/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_IssueInputs */

const en_admin_dashboard_issue = /** @type {(inputs: Admin_Dashboard_IssueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issue`)
};

const de_admin_dashboard_issue = /** @type {(inputs: Admin_Dashboard_IssueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thema`)
};

const es_admin_dashboard_issue = /** @type {(inputs: Admin_Dashboard_IssueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asunto`)
};

const fr_admin_dashboard_issue = /** @type {(inputs: Admin_Dashboard_IssueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problème`)
};

const it_admin_dashboard_issue = /** @type {(inputs: Admin_Dashboard_IssueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problema`)
};

const pt_br2_admin_dashboard_issue = /** @type {(inputs: Admin_Dashboard_IssueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chamado`)
};

const pl_admin_dashboard_issue = /** @type {(inputs: Admin_Dashboard_IssueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problem`)
};

const hu_admin_dashboard_issue = /** @type {(inputs: Admin_Dashboard_IssueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Probléma`)
};

const ro_admin_dashboard_issue = /** @type {(inputs: Admin_Dashboard_IssueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problema`)
};

/**
* | output |
* | --- |
* | "Issue" |
*
* @param {Admin_Dashboard_IssueInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_issue = /** @type {((inputs?: Admin_Dashboard_IssueInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_IssueInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_issue(inputs)
	if (locale === "de") return de_admin_dashboard_issue(inputs)
	if (locale === "es") return es_admin_dashboard_issue(inputs)
	if (locale === "fr") return fr_admin_dashboard_issue(inputs)
	if (locale === "it") return it_admin_dashboard_issue(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_issue(inputs)
	if (locale === "pl") return pl_admin_dashboard_issue(inputs)
	if (locale === "hu") return hu_admin_dashboard_issue(inputs)
	return ro_admin_dashboard_issue(inputs)
});
export { admin_dashboard_issue as "admin.dashboard.issue" }